module.exports = __webpack_public_path__ + "img/2.6dbad761.png";